import type { FC } from "react";

import { InputAdornment, Stack, TextField, Typography } from "@mui/material";
import CustomSwitch from "../../../CustomSwitch";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface RulesTabHeurekaCaseProps {
  minReviewStars?: number;
  minReviews?: number;
  withRepeat: boolean;
  onChangeMinReviewStars?: (value: number) => void;
  onChangeMinReviews?: (value: number) => void;
  onToggleWithRepeat: () => void;
}

export const RulesTabHeurekaCase: FC<RulesTabHeurekaCaseProps> = ({
  minReviewStars,
  minReviews,
  withRepeat,
  onChangeMinReviews,
  onChangeMinReviewStars,
  onToggleWithRepeat,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack direction='row' flexWrap='wrap' py={2}>
      <Stack spacing={2} sx={{ width: 1 }}>
        <TextField
          fullWidth
          sx={{ width: 1 }}
          type='number'
          label={t(
            "campaign.notifications.settings.displayRules.heureka.reviewsWithRating",
          )}
          variant='outlined'
          value={minReviewStars}
          onChange={e =>
            onChangeMinReviewStars &&
            onChangeMinReviewStars(Number(e.target.value))
          }
          InputProps={{
            inputProps: { min: 0, style: { height: 10 } },
            endAdornment: (
              <InputAdornment position='end'>
                <Typography
                  style={{ color: theme.palette.natural.t1, fontSize: 14 }}
                >
                  {t(
                    "campaign.notifications.settings.displayRules.heureka.stars",
                  )}
                </Typography>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          sx={{ width: 1 }}
          type='number'
          variant='outlined'
          label={t(
            "campaign.notifications.settings.displayRules.heureka.maxReviews",
          )}
          value={minReviews}
          onChange={e =>
            onChangeMinReviews && onChangeMinReviews(Number(e.target.value))
          }
          InputProps={{
            inputProps: { min: 0 },
            style: { height: 44 },
          }}
        />
      </Stack>
      <Stack direction='row' justifyContent='space-between' sx={{ width: 1 }}>
        <Typography
          mt={1}
          style={{ color: theme.palette.natural.t1, fontSize: 14 }}
        >
          {t("campaign.notifications.settings.displayRules.repeatNotification")}
        </Typography>
        <CustomSwitch checked={withRepeat} onSwitch={onToggleWithRepeat} />
      </Stack>
    </Stack>
  );
};
